import React, {useCallback} from "react";
import {bool, string, func, oneOfType, object} from "prop-types";
import Text from "features/components/text";
import "./index.scss";
import {Icon} from "features/components/icon";

const Checkbox = (props) => {
    const {value, label, onChange} = props;
    const toggleCheck = useCallback(() => {
        onChange(!value);
    }, [value, onChange]);
    return <div className={`checkbox ${value ? "checked" : ""}`} >
        <span onClick={toggleCheck} className="indicator"><Icon>check</Icon></span>
        <Text size={16}>{label}</Text>
    </div>
};

Checkbox.propTypes = {
    value: bool.isRequired,
    onChange: func.isRequired,
    label: oneOfType([string, object])
};

export default Checkbox;